import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
//import moment from 'moment-timezone';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TicketContainer from '../../containers/Ticket/Ticket';
import TicketCategoryContainer from '../../containers/Ticket/TicketCategory';

//- UI / Form
import FormSubmitButton from '../../components/form/FormSubmitButton';
//import FormText from '../../components/form/FormText';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import {gridMargin} from "../components/form/general";

//import SectionHeader from "../../components/SectionHeader";
//import CompanyDepartmentPicker from "../../components/advancedForm/CompanyDepartmentPicker";
import TicketCategoryPicker from '../../components/advancedForm/TicketCategoryPicker';
//import PermissionPicker from "../../components/advancedForm/PermissionPicker";
//import Note from "../../components/Note";
import FormText from '../../components/form/FormText';
import FormTextArea from '../../components/form/FormTextArea';
import FormDatePicker from '../../components/form/FormDatePicker';
import FormTimePicker from '../../components/form/FormTimePicker';
import SectionHeader from '../../components/SectionHeader';
import UserPicker from '../../components/advancedForm/UserPicker';
import FormCheckbox from '../../components/form/FormCheckbox';
import Note from '../../components/Note';
import { post } from '../../modules/utility';

import FleetPicker from '../../components/advancedForm/FleetPicker';
import FleetDepartmentPicker from '../../components/advancedForm/FleetDepartmentPicker';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import FormFileUploader from '../../components/form/FormFileUploader';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickACategory: {
			padding: 20,
			backgroundColor: '#eee',
			borderColor: '1px solid #ccc',
			fontSize: 18,
			color: '#999',
			borderRadius: 10,
			width: '100%',
		},
		formDivider: {
			width: '100%',
			marginTop: 10,
			border: '1px dashed #ddd',
			marginBottom: 15,
		},
		activityContainer: {
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 5,
			[theme.breakpoints.up('sm')]: {
				borderLeft: 'none',
			},
		},
		activityUserRow: {
			marginTop: 10,
			marginBottom: 5,
		},
		activityUser: {
			whiteSpace: 'nowrap',
			fontWeight: 800,
			marginRight: 5,
		},
		activityText: {},
		activityTypeRow: {
			marginBottom: 15,
		},
		activityDate: {
			fontSize: '85%',
			color: '#666',
			paddingBottom: 2,
			[theme.breakpoints.up('sm')]: {
				paddingTop: 2,
			},
		},
		activityType: {
			display: 'inline-block',
			fontWeight: 500,
			fontSize: '85%',
			padding: '5px 10px',
			marginRight: 5,
			borderRadius: 2,
		},
		comment: {
			color: '#0288D1',
			backgroundColor: '#E1F5FE',
		},
		update: {
			color: '#546E7A',
			backgroundColor: '#ECEFF1',
		},
		completed: {
			color: '#43A047',
			backgroundColor: '#E8F5E9',
		},
		incomplete: {
			color: '#D32F2F',
			backgroundColor: '#FFEBEE',
		},
		opened: {
			color: '#AFB42B',
			backgroundColor: '#F9FBE7',
		},
		driverReport: {
			color: '#5E35B1',
			backgroundColor: '#EDE7F6',
		},
		downloadButton: {
			verticalAlign: 'middle',
			margin: '0px 10px',
			padding: '4px 10px',
		},
	};
};

const idField = 'ticketId';
//const itemDisplay = 'Ticket';

class Save extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
		const isUpdate = action === 'update';

		this.state = {
			[idField]: id,
			isUpdate,

			ticketIsComplete: false,
			formHasBeenFilled: false,
			ticketCategoryId: '',
			ticketSchema: undefined,
			formFieldError: {},
			fleetUsersToCc: {},
			fleetConfig: null,
		};
	}

	componentDidMount() {
		post({
			method: 'ticket.getFleetConfig',
			params: {},
			callback: (err, result) => {
				if (!err) {
					this.setState({ fleetConfig: result });
				}
			},
		});

		const {
			ticket,
			getTicket,
			ticketChangeLogs,
			getTicketChangeLogs,
			ticketCategories,
			searchTicketCategories,
		} = this.props;

		const { ticketId, isUpdate } = this.state;
		if (!isUpdate) {
			return;
		}

		if (!ticketChangeLogs) {
			getTicketChangeLogs({ ticketId });
		}

		if (ticket && ticketCategories) {
			this.fillForm();
			return;
		}

		if (!ticket) {
			getTicket({
				params: { ticketIds: [ticketId] },
			});
		}

		if (_.isEmpty(ticketCategories)) {
			searchTicketCategories();
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { ticket, ticketCategories, ticketSchemaMap } = this.props;
		const { formHasBeenFilled, isUpdate } = this.state;

		if (
			isUpdate &&
			ticket &&
			!_.isEmpty(ticketCategories) &&
			!formHasBeenFilled &&
			!prevState.formHasBeenFilled
		) {
			this.fillForm();
		}

		const newState = {};

		//- When the ticketCategory changes, change the schema
		const { ticketCategoryId } = this.state;

		if (prevState.ticketCategoryId !== ticketCategoryId) {
			if (!ticketCategoryId) {
				newState.ticketSchema = undefined;
			} else {
				const ticketCategory = _.find(ticketCategories, { ticketCategoryId });
				if (!ticketCategory) {
					console.error('Could not find ticketCategory', ticketCategory);
					return;
				}

				const {
					ticketSchemaId,
					assignToType,
					defaultAssignedToUserId,
					defaultFleetUsersToCc,
					defaultUserIdsToCc,
				} = ticketCategory;

				const ticketSchema = ticketSchemaMap[ticketSchemaId];
				if (!ticketSchema) {
					console.error(
						'Could not find ticketSchema from category',
						ticketCategory,
						ticketSchemaMap
					);
					return;
				}

				if (assignToType === 'defaultAssignedToUserId') {
					if (!this.state.assignedToUserId) {
						newState.assignedToUserId = defaultAssignedToUserId;
					}
					newState.assignToTerminalManager = false;
				} else {
					newState.assignToTerminalManager = true;
				}

				if (_.isEmpty(this.state.userIdsToCc)) {
					newState.userIdsToCc = defaultUserIdsToCc;

					if (!_.isEmpty(defaultFleetUsersToCc)) {
						newState.fleetUsersToCc = {};
						defaultFleetUsersToCc.forEach((fleetUser) => {
							newState.fleetUsersToCc[fleetUser] = true;
						});
					}
				}

				newState.ticketSchema = ticketSchema;
			}
		}

		if (!_.isEmpty(newState)) {
			this.setState(newState);
		}
	}

	fillForm = () => {
		const { ticket, ticketCategories } = this.props;
		if (!ticket || _.isEmpty(ticketCategories)) {
			return;
		}

		const newState = {
			formHasBeenFilled: true,
		};
		['ticketCategoryId', 'ticketIsComplete'].forEach((key) => {
			if (_.isNil(ticket[key])) {
				return;
			}
			newState[key] = ticket[key];
		});

		const { schemaValues } = ticket;
		_.keys(schemaValues).forEach((key) => {
			if (_.isNil(schemaValues[key])) {
				return;
			}
			newState[key] = schemaValues[key];
		});

		this.setState(newState);
	};

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;

		if (path === 'fleetDepartment') {
			this.addEmailsOnFleetChange({ newState, fleetDepartment: value });
		}
		if (path === 'driverUserId') {
			this.updateAssignedToManager({ newState, driverUserId: value });
		}

		this.setState(newState);
	};

	addEmailsOnFleetChange({ newState, fleetDepartment }) {
		const {
			userIdsToCc,
			assignToTerminalManager,
			driverUserId,
			fleetUsersToCc,
			fleetConfig,
		} = this.state;

		//- Get the TM for the fleet
		const tmUserId =
			fleetConfig && fleetConfig.fleetDepartmentToTerminalManagerUserId[fleetDepartment];
		const taUserId =
			fleetConfig && fleetConfig.fleetDepartmentToTerminalAdminUserId[fleetDepartment];
		const mechUserId = fleetConfig && fleetConfig.fleetDepartmentToMechUserId[fleetDepartment];
		const newUserIdsToCc = [];

		//- New just for billing - Joey request on 12/17
		let managerUserId;
		if (driverUserId) {
			managerUserId = fleetConfig && fleetConfig.userIdToManagerUserId[driverUserId];
		}

		//- Shift & HR : Assign to Terminal Manager, CC Terminal Admin
		if (assignToTerminalManager) {
			newState.assignedToUserId = tmUserId;
		}

		//- direct manager overrides them
		if (managerUserId) {
			newState.assignedToUserId = managerUserId;
		}

		if (fleetUsersToCc.terminalManagerForFleet && tmUserId) {
			newUserIdsToCc.push(tmUserId);
		}
		if (fleetUsersToCc.terminalAdminForFleet && taUserId) {
			newUserIdsToCc.push(taUserId);
		}
		if (fleetUsersToCc.mechanicalGroupForFleet && mechUserId) {
			newUserIdsToCc.push(mechUserId);
		}

		newState.userIdsToCc = _.compact(_.uniq(userIdsToCc.concat(newUserIdsToCc)));
	}

	updateAssignedToManager({ newState, driverUserId }) {
		const { fleetDepartment, assignToTerminalManager, fleetConfig } = this.state;

		//- New just for billing - Joey request on 12/17
		const tmUserId =
			fleetConfig && fleetConfig.fleetDepartmentToTerminalManagerUserId[fleetDepartment];

		if (driverUserId) {
			const managerUserId = fleetConfig && fleetConfig.userIdToManagerUserId[driverUserId];
			if (managerUserId) {
				newState.assignedToUserId = managerUserId;
			} else if (assignToTerminalManager) {
				if (assignToTerminalManager) {
					newState.assignedToUserId = tmUserId;
				}
			}
		}
	}

	handleSave = () => {
		const { addTicket, updateTicket, showErrors } = this.props;

		const { isUpdate, ticketId } = this.state;

		const formFieldError = {};

		const requiredFields = [{ path: 'ticketCategoryId', label: 'Ticket Category' }];

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { ticketCategoryId, ticketSchema, comment, ticketIsComplete } = this.state;

		const { ticketSchemaId } = ticketSchema;

		const schemaValues = {};
		ticketSchema.items.forEach((item) => {
			const { path, isRequired, label } = item;
			if (!path) {
				return;
			}

			const value = this.state[path];

			if (!value && isRequired) {
				formFieldError[path] = `${label} is required`;
				return;
			}

			if (_.isUndefined(value)) {
				return;
			}
			schemaValues[path] = value;
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			ticketCategoryId,
			ticketSchemaId,
			schemaValues,
		};

		if (!isUpdate) {
			addTicket({ params });
		} else {
			//- Check for comments
			if (comment) {
				params.comment = comment;
			}
			params.ticketIsComplete = ticketIsComplete;
			params.ticketId = ticketId;
			updateTicket({ params });
		}
	};

	getItemProps = (item, defaultValue) => {
		const { path, isHalfWidth } = item;
		const md = isHalfWidth ? 6 : 12;

		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md },
		};
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { classes, ticket } = this.props;

		const { isUpdate, ticketSchema } = this.state;

		if (this.props.authUser?.role === 'driver') {
			return <div>You are not authorized to view this page.</div>;
		}

		/** @namespace classes.globalFetching **/
		if (isUpdate && !ticket) {
			return <div className={classes.globalFetching}>Fetching ticket...</div>;
		}

		return (
			<form>
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<div className={classes.globalMainHeadline}>Ticket Info</div>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={12} md={11} lg={10}>
							<Grid spacing={2} container>
								<TicketCategoryPicker
									{...this.getInputProps('ticketCategoryId')}
									helpText={'Pick a ticket category to display fields for that category'}
								/>
								<div className={classes.formDivider} />

								{!ticketSchema && (
									<div className={classes.pickACategory}>Ticket category fields will show here</div>
								)}
								{ticketSchema && this.renderTicketSchema()}

								{!isUpdate && (
									<FormSubmitButton onClick={this.handleSave} buttonText={`Create Ticket`} />
								)}
							</Grid>
						</Grid>
					</Grid>
				</Paper>
				{isUpdate && this.renderActivity()}
				{isUpdate && this.renderUpdateSection()}
			</form>
		);
	}

	renderTicketSchema = () => {
		const { ticketSchema } = this.state;

		return (
			<Fragment>
				{ticketSchema.items.map((item) => {
					const { type } = item;

					if (type === 'text') {
						return this.renderText(item);
					} else if (type === 'textArea') {
						return this.renderTextArea(item);
					} else if (type === 'checkbox') {
						return this.renderCheckbox(item);
					} else if (type === 'tmwOrderId') {
						return this.renderTmwOrderId(item);
					} else if (type === 'datePicker') {
						return this.renderDatePicker(item);
					} else if (type === 'timePicker') {
						return this.renderTimePicker(item);
					} else if (type === 'userPicker') {
						return this.renderUserPicker(item);
					} else if (type === 'fleetDepartmentPicker') {
						return this.renderFleetDepartmentPicker(item);
					} else if (type === 'fleetPicker') {
						return this.renderFleetPicker(item);
					} else if (type === 'fileUploader') {
						return this.renderFileUploader(item);
					} else if (type === 'sectionHeader') {
						return this.renderSectionHeader(item);
					} else {
						return <div>Missing : {type}</div>;
					}
				})}
			</Fragment>
		);
	};

	renderText = (item) => {
		return (
			<FormText
				{...this.getItemProps(item)}
				key={item.id}
				label={item.label}
				required={item.isRequired || false}
				helpText={item.helpText}
			/>
		);
	};

	renderTextArea = (item) => {
		const { isUpdate } = this.state;

		let helpText = item.helpText;
		let disabled = false;
		if (item.path === 'details' && isUpdate) {
			disabled = true;
			helpText = 'No updating original details. Please add comment.';
		}

		return (
			<FormTextArea
				{...this.getItemProps(item)}
				key={item.id}
				label={item.label}
				rows={4}
				required={item.isRequired || false}
				helpText={helpText}
				disabled={disabled}
			/>
		);
	};

	renderCheckbox = (item) => {
		let helpText = item.helpText;
		let disabled = false;
		return (
			<FormCheckbox
				{...this.getItemProps(item, false)}
				key={item.id}
				label={item.label}
				required={item.isRequired || false}
				helpText={helpText}
				disabled={disabled}
				formControlStyle={{ marginTop: 20 }}
			/>
		);
	};

	renderTmwOrderId = (item) => {
		return (
			<FormText
				{...this.getItemProps(item)}
				key={item.id}
				label={item.label}
				required={item.isRequired || false}
				helpText={item.helpText}
			/>
		);
	};

	renderDatePicker = (item) => {
		return (
			<FormDatePicker
				{...this.getItemProps(item)}
				key={item.id}
				label={item.label}
				required={item.isRequired || false}
				helpText={item.helpText}
			/>
		);
	};

	renderTimePicker = (item) => {
		return (
			<FormTimePicker
				{...this.getItemProps(item)}
				key={item.id}
				label={item.label}
				required={item.isRequired || false}
				helpText={item.helpText}
			/>
		);
	};

	renderUserPicker = (item) => {
		return (
			<UserPicker
				{...this.getItemProps(item, null)}
				required={item.isRequired || false}
				whoToShow={item.whoToShow || 'all'}
				selectMultiple={item.selectMultiple || false}
				helpText={item.helpText}
				key={item.id}
				label={item.label}
			/>
		);
	};

	renderFleetDepartmentPicker = (item) => {
		return (
			<FleetDepartmentPicker
				{...this.getItemProps(item, '')}
				required={item.isRequired || false}
				helpText={item.helpText}
				key={item.id}
				label={item.label}
			/>
		);
	};

	renderFleetPicker = (item) => {
		return (
			<FleetPicker
				{...this.getItemProps(item, '')}
				required={item.isRequired || false}
				helpText={item.helpText}
				key={item.id}
				label={item.label}
			/>
		);
	};

	renderFileUploader = (item) => {
		return (
			<FormFileUploader
				{...this.getItemProps(item, '')}
				required={item.isRequired || false}
				helpText={item.helpText}
				key={item.id}
				label={item.label}
			/>
		);
	};

	renderSectionHeader = (item) => {
		return <SectionHeader {...this.getItemProps(item, null)} key={item.id} label={item.label} />;
	};

	renderActivity = () => {
		const { ticket, ticketChangeLogs, userMap, resourceMap, classes } = this.props;
		const { comments } = ticket;

		let logs = [];
		if (!_.isEmpty(ticketChangeLogs)) {
			logs = ticketChangeLogs;
		}
		if (!_.isEmpty(comments)) {
			logs = logs.concat(comments);
		}

		logs = _.sortBy(logs, 'dateCreated');

		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>Activity</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={11} lg={10}>
						{!_.isEmpty(logs) &&
							logs.map((log) => {
								const {
									ticketChangeLogId,
									entry,
									ticketCommentId,
									comment,
									changeType,
									creatorUserId,
									dateCreated,
									attachmentResourceId,
								} = log;

								const isComment = ticketCommentId;

								let text, id, typeClass, typeDisplay;

								if (isComment) {
									text = `commented "${comment}"`;
									id = ticketCommentId;
									typeClass = 'comment';
									typeDisplay = 'comment';
								} else {
									text = entry;
									id = `cl_${ticketChangeLogId}`;
									typeClass = changeType;
									typeDisplay = { driverReport: 'employee report' }[changeType] || changeType;
								}

								const user = userMap[creatorUserId] || {
									firstName: 'Missing',
									lastName: 'Missing',
								};

								const dateFormatted = moment(dateCreated).format('M/D h:mm a');

								let resource;
								if (attachmentResourceId) {
									resource = resourceMap[attachmentResourceId];
								}

								return (
									<Grid container item md={12} className={classes.activityContainer} key={id}>
										<Grid item xs={12} sm={12}>
											<div className={classes.activityUserRow}>
												<span className={classes.activityUser}>
													{user.firstName} {user.lastName}
												</span>
												<span className={classes.activityText}>{text}</span>
											</div>
											<div className={classes.activityTypeRow}>
												<span className={`${classes.activityType} ${classes[typeClass]}`}>
													{typeDisplay}
												</span>
												<span className={classes.activityDate}>{dateFormatted}</span>
												{resource && (
													<a
														href={resource.url}
														target="_blank"
														rel="noreferrer noopener"
														style={{ textDecoration: 'none' }}
													>
														<Button
															variant="outlined"
															color="primary"
															size="small"
															className={classes.downloadButton}
														>
															<DownloadIcon style={{ marginRight: 10 }} />
															Download Report
														</Button>
													</a>
												)}
											</div>
										</Grid>
									</Grid>
								);
							})}
					</Grid>
				</Grid>
			</Paper>
		);
	};

	renderUpdateSection = () => {
		const { classes } = this.props;
		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>Update</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={11} lg={10}>
						{this.renderAddComment()}
						{this.renderVerifyComplete()}
					</Grid>
				</Grid>

				<FormSubmitButton onClick={this.handleSave} buttonText={`Update Ticket`} />
			</Paper>
		);
	};

	renderAddComment = () => {
		return (
			<Fragment>
				<FormTextArea {...this.getInputProps('comment')} label={'Add comment'} rows={3} />
			</Fragment>
		);
	};

	renderVerifyComplete = () => {
		return (
			<Grid item xs={12}>
				<Note>
					<FormCheckbox
						{...this.getInputProps('ticketIsComplete')}
						label={'Mark Ticket Complete'}
						showLargeFont={true}
					/>
					<div>
						<strong>Note</strong>: Only mark ticket as complete if you can verify work as been done.
						If the ticket is not complete, uncheck the checkbox and update the ticket.
					</div>
				</Note>
			</Grid>
		);
	};
}

Save.propTypes = {
	getTicket: PropTypes.func.isRequired,
	ticket: PropTypes.object,

	getTicketChangeLogs: PropTypes.func.isRequired,
	ticketChangeLogs: PropTypes.array,

	addTicket: PropTypes.func.isRequired,
	updateTicket: PropTypes.func.isRequired,

	searchTicketCategories: PropTypes.func.isRequired,
	ticketCategories: PropTypes.array,
	ticketSchemaMap: PropTypes.object,
	resourceMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TicketContainer,
	TicketCategoryContainer,
])(Save);
